<template lang="html">
  <div>I'm scene 2</div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
  div { color: red }
</style>
